import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IErrorState } from '../models/error-state.interface';
import { IValidationMessage } from '../models/validation-message.interface';
import { IRangeDictionaryItem } from '../models/range-dictionary-item.interface';

@Injectable({
    providedIn: 'root'
})
export class ValidationService {

    constructor() {
    }

    /**
     * Валидация номера карты
     *
     * @param control - FormControl для валидации
     */
    static luhnAlgorithm(control: FormControl): IErrorState {
        let sum = 0;
        const cardNumber = control.value || '';

        for (let i = 0; i < cardNumber.length; i++) {
            let cardNum = parseInt(cardNumber[i], 10);

            if ((cardNumber.length - i) % 2 === 0) {
                cardNum = cardNum * 2;

                if (cardNum > 9) {
                    cardNum = cardNum - 9;
                }
            }

            sum += cardNum;
        }

        return (sum % 10 === 0) ? null : { incorrectCardNumber: true };
    }

    /**
     * Валидация месяца срока действия карты
     *
     * @param control - FormControl для валидации
     */
    static expireDateMonth(control: FormControl): IErrorState {
        const value = Number(control.value);
        return value > 12 || value <= 0 || isNaN(value) ? { incorrectCardExpireMonth: true } : null;
    }

    /**
     * Валидаця первых цифр номера карты на предмет вхождения их в рейнджи для ПС МИР
     *
     * @param control - FormControl с pan карты
     * @param rangeDictionary - Справочник рейнджей, забронированных под ПС МИР
     */
    static cardRangeValidation(control: FormControl, rangeDictionary: IRangeDictionaryItem[]): IErrorState {
        const rangeList = rangeDictionary?.map(range => range.range);
        const value = control.value;

        const result = rangeList?.reduce((res, range) => {
            const checkValue = value.substring(0, range.length);

            return res || checkValue === range;
        }, false);

        return result ? null : { incorrectCardRange: true };
    }

    /**
     * Находит человекочитаемое сообщение об ошибке из переданного списка по коду и возвращает его или undefined
     *
     * @param errorCode - код ошибки валидации
     * @param errorList - массив ошибок валидации с человекочитаемыми текстами
     */
    static getValidationMessage(errorCode: string, errorList: IValidationMessage[]): string {
        return errorList?.find(errorItem => errorItem.error === errorCode)?.message;
    }
}
